import "../../css/pages/homePage.scss";
import BasePage from "./base";
import slashImageBlock from "../modules/slashImageBlock";
import largeCardCarousel from "../modules/largeCardCarousel";
import heroHomePage from "../modules/heroHomePage";
import relatedInsights from "../modules/relatedInsights";
import homepageIndustries from "../modules/homepageIndustries";
import titleRobotoFlex from "../modules/titleRobotoFlex";

class HomePage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        super.initRellax();
    }

    onReady() {
        super.onReady();
        heroHomePage.init();
        relatedInsights.init();
        largeCardCarousel.init();
        homepageIndustries.init();
        titleRobotoFlex.init();
        slashImageBlock.init();
    }
}

new HomePage();
